import React from 'react';

export function AdminBookingsTab({ bookings }) {
  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-2xl font-bold text-white" style={{ fontFamily: 'Chivo, sans-serif' }}>
          Consulting Bookings
        </h1>
        <span className="text-[#71717A]">{bookings.length} bookings</span>
      </div>
      
      <div className="bg-[#141417] border border-[#27272A] rounded-md overflow-hidden">
        <table className="data-table">
          <thead>
            <tr className="bg-[#09090B]">
              <th>Date</th>
              <th>Time</th>
              <th>Client</th>
              <th>Topic</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {bookings.map(b => (
              <tr key={b.id}>
                <td className="text-white font-mono">{b.date}</td>
                <td className="text-[#A1A1AA] font-mono">{b.time_slot}</td>
                <td>
                  <div>
                    <span className="text-white">{b.name}</span>
                    <span className="text-[#71717A] text-sm block">{b.email}</span>
                  </div>
                </td>
                <td className="text-[#A1A1AA]">{b.topic}</td>
                <td>
                  <span className={`px-2 py-1 rounded-sm text-xs ${
                    b.status === 'confirmed' ? 'bg-[#00FF66]/10 text-[#00FF66]' : 'bg-[#27272A] text-[#71717A]'
                  }`}>
                    {b.status}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
